import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { toast } from 'react-toastify';

const deletePuzzleItem = (id: number) => api.delete(`/puzzle-item/${id}`);

export const useDeletePuzzleItemMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['delete-puzzle-item'],
    mutationFn: deletePuzzleItem,
    onSuccess: () => {
      toast.success('Puzzle item deleted successfully');

      queryClient.invalidateQueries({
        queryKey: ['puzzle-items'],
      });
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
